import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "section"]

  connect() {
    this.showSection(this.selectTarget.value)
  }

  providerChanged() {
    this.showSection(this.selectTarget.value)
  }

  showSection(provider) {
    this.sectionTargets.forEach(section => {
      const isMatch = section.dataset.provider === provider
      section.classList.toggle("hidden", !isMatch)
      section.querySelectorAll("input").forEach(input => {
        input.disabled = !isMatch
      })
    })
  }
}
